import React, { useState } from "react";
import styles from "./UpsertAccountModal.module.scss";
import { BaseModal } from "@whatslly/ui-components/modals/BaseModal";
import { IModalInstance, ModalHeader } from "@whatslly/ui-components/modals";
import { TextInput } from "@whatslly/ui-components/v2/BaseElements/TextInput";
import { useTranslation } from "react-i18next";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";

type CreateNewAccountModalProps = IModalInstance<{
  name: string;
}>;

export const CreateNewAccountModal: React.FC<CreateNewAccountModalProps> = ({ closeModal }) => {
  const { t } = useTranslation();
  const [name, setName] = useState<string>("");

  return (
    <BaseModal
      header={<ModalHeader closeModal={closeModal}>{t("search_accounts.create_new_account")}</ModalHeader>}
      closeOnClickOutside={false}
      closeOnEscape={true}
      closeModal={closeModal}
      className={styles.modal}
      bodyClassName={styles.body}
      backdropClassName={styles.backdrop}
    >
      <div className={styles.form}>
        <TextInput
          containerClassName={styles.textbox}
          placeholder={t("account_admin.overview_page.account_name")}
          data-testid="account-name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
      </div>
      <ModalButtons
        isSubmitDisabled={name.length < 2}
        testId="modal-buttons-submit-button"
        onCancel={closeModal}
        onSubmit={() => closeModal({ name })}
      />
    </BaseModal>
  );
};
